import { useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import { inclusionPendencies } from '../../../../../commons/order-checklist';

const SendFinancialAnalysisButton = ({ order }) => {
  const { hasPermissions } = useContext(AuthContext);

  const valid_order_status =
    order.order_status === 'Em inclusão' ||
    order.order_status === 'Financeiro negado';

  const valid_permissions = hasPermissions(['add_order']);

  // FEAT-015: checklist de pendências (fonte única em commons/order-checklist).
  // O botão fica VISÍVEL porém desabilitado enquanto houver pendências — o
  // vendedor vê exatamente o que falta para enviar à análise.
  const pendencies = inclusionPendencies(order);

  const ready = pendencies.length === 0;

  return (
    <>
      {valid_order_status && valid_permissions && (
        <div className="col-sm col-md-5 col-xl-3 mt-2">
          {!ready && (
            <div
              className="alert alert-warning py-2 px-3 mb-2 text-start"
              style={{ fontSize: '12px', textTransform: 'none' }}
            >
              <b>Pendências para enviar à análise:</b>
              <ul className="mb-0 ps-3">
                {pendencies.map((pendency) => (
                  <li key={pendency}>{pendency}</li>
                ))}
              </ul>
            </div>
          )}

          <button
            className="btn btn-success btn-block col-12"
            type="button"
            disabled={!ready}
            data-bs-toggle={ready ? 'modal' : undefined}
            data-bs-target={ready ? '#modal-send-finance' : undefined}
          >
            enviar para análise
          </button>
        </div>
      )}
    </>
  );
};

SendFinancialAnalysisButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
    sig_number: PropTypes.number,
    spcfiles: PropTypes.arrayOf(Object),
    products: PropTypes.arrayOf(Object),
    photos: PropTypes.arrayOf(Object),
  }).isRequired,
};

export default SendFinancialAnalysisButton;
